module.exports = __webpack_public_path__ + "static/img/32d33cfd6ead3276031a1281a4ddf1ad3a627cde.85e11443.png";